import React, { useState, useContext } from 'react';

import { If, user } from 'utils';
import { UiKit } from 'components';
import ChangePasswordForm from './ChangePasswordForm';
import { AuthContext } from 'context/AuthContext';

export default function ChangePasswordModal() {
  const [isSuccess, setIsSuccess] = useState(false);

  const {
    isExternalUser,
    changePasswordModal: showModal,
    toggleChangePasswordModal: onModalToggle
  } = useContext(AuthContext);

  const onPasswordUpdated = () => {
    setIsSuccess(true);
    setTimeout(() => {
      onModalToggle();
      user.logout();
      window.location.href = '/login?fromChangePassword=true';
    }, 2000);
  };

  if (isExternalUser) return null;

  return (
    <UiKit.Modal
      isOpen={showModal}
      title="Change Password"
      onClose={onModalToggle}
    >
      <UiKit.Modal.Header title="Change Password" />
      <UiKit.Modal.Body>
        <If test={!isSuccess}>
          <ChangePasswordForm
            onCancel={onModalToggle}
            onSuccess={onPasswordUpdated}
          />
        </If>
        <If test={isSuccess}>
          <div className="text-center mt-4 mb-4 ChangePassword__success">
            <i class="far fa-check-circle fa-7x" />
            <p className="text">Password has been successfully changed.</p>
            <p>
              Redirecting you to login screen. Please login again with your new
              password.
            </p>
          </div>
        </If>
      </UiKit.Modal.Body>
    </UiKit.Modal>
  );
}
